import React from 'react';

const Breadcrumb = ({ currentPage = 1, totalPages = 13 }) => {
  return (
    <div className="px-4 md:px-8 lg:px-16 py-4">
      <nav className="flex items-center gap-2 text-xs tracking-widest uppercase text-gray-600">
        <a href="/" className="hover:text-[#1a365d] transition-colors">Home</a>
        <span>/</span>
        <a href="#" className="hover:text-[#1a365d] transition-colors">Engagement Rings</a>
        <span>/</span>
        <span>Page {currentPage} of {totalPages}</span>
      </nav>
    </div>
  );
};

export default Breadcrumb;
